import { CallService } from "./../CallService";
import { useAuthStoreSelectors } from "@/shared/stores";
import { useQuery } from "@tanstack/react-query";

interface GetMissedCallsProps {
  date_start: string;
  date_end: string;
}

export const useGetMissedCalls = ({
  date_start,
  date_end,
}: GetMissedCallsProps) => {
  const user_id = useAuthStoreSelectors.use.user_id();

  const { data, refetch } = useQuery({
    queryKey: ["missed_calls"],
    queryFn: async () => {
      const response = await CallService.getMissedCalls({
        user_id: user_id || "",
        date_start,
        date_end,
      });

      return response?.data.calls;
    },
    enabled: false,
  });

  return {
    calls: data ?? [],
    refetch,
  };
};
